/** @file Parent index per compiled bone index (-1 for the root), for update-order graph walks. */
import type { Doc } from '@pose2d/format/types';

/** `parents[i]` = compiled index of bone i's parent, or -1 (root, or a parent outside `boneIndex`). */
export function compiledBoneParents(doc: Doc, boneIndex: ReadonlyMap<string, number>): number[] {
  const parents = new Array<number>(boneIndex.size).fill(-1);
  for (const [id, i] of boneIndex) {
    const parent = doc.bones[id]?.parent ?? null;
    parents[i] = parent === null ? -1 : (boneIndex.get(parent) ?? -1);
  }
  return parents;
}
